<div *ngIf="false; else digitalCustomerAuthModal">
  <!--TODO dormancy to be added-->
  <tmo-dynamic-modal
    pdlPageComponentId="customer-authentication-dynamic-modal"
    [displayModal]="displayModal"
    [aemContent]="aemContent"
    [modal]="modal"
  >
    <ng-container header>
      <div class="modal-logo-close">
        <i class="logo-icon t-icon t-icon-logo"></i>
        <a
          id="close-x"
          href="javascript:void(0)"
          aria-label="Close"
          class="close-x"
          (click)="closeCustomerAuthenticationModal()"
        >
          <i class="fa fa-times"></i>
        </a>
      </div>
      <h3>{{ aemContent?.areYouAnExistingCustomer }}</h3>

      <p class="small">{{ aemContent?.loggingInCanGiveYouAccuratePricing }}</p>
    </ng-container>
    <ng-container>
      <div class="row">
        <div class="col-12 buttons-container button-spacing">
          <div class="button-box">
            <button
              id="new-customer-button"
              class="btn btn-secondary"
              aria-label="aemContent?.newCustomer"
              (click)="onNewCustomerSelection()"
            >
              {{ aemContent?.newCustomer }}
            </button>
          </div>
          <div class="button-box">
            <button
              id="existing-customer-button"
              class="btn btn-primary"
              aria-label="aemContent?.existingCustomer"
              (click)="closeExistingCustomerModal()"
            >
              {{ aemContent?.existingCustomer }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </tmo-dynamic-modal>
</div>
<ng-template #digitalCustomerAuthModal>
  <tmo-digital-customer-authentication-modal
    [displayModal]="displayModal"
    [aemContent]="aemContent"
    (closeModal)="closeCustomerAuthenticationModal($event)"
    (newCustomer)="onNewCustomerSelection($event)"
    (closeExistingCustModal)="closeExistingCustomerModal()"
  ></tmo-digital-customer-authentication-modal>
</ng-template>
